import * as React from 'react';
import type { SVGProps } from 'react';
import { memo } from 'react';
export const SvgAddPlayerDimension = {
  height: 16,
  width: 16,
  viewBox: '0 0 16 16',
};
export const SvgAddPlayer = memo((props: SVGProps<SVGSVGElement>) => (
  <svg width={16} height={16} viewBox="0 0 16 16" fill="none" {...props}>
    <g clipPath="url(#a)">
      <mask
        id="b"
        x="0"
        y="0"
        width="16"
        height="16"
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'luminance',
        }}
      >
        <path fill="#fff" d="M16 0H0v16h16z" />
      </mask>
      <g mask="url(#b)">
        <mask
          id="c"
          width={16}
          height={16}
          x={0}
          y={0}
          maskUnits="userSpaceOnUse"
          style={{
            maskType: 'alpha',
          }}
        >
          <path fill="#203166" d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
        </mask>
        <g filter="url(#d)" mask="url(#c)">
          <path fill="#0072ee" d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
        </g>
        <path
          fill="#fff"
          d="M11.428 8.571H8.571v2.858A.573.573 0 0 1 8 12a.573.573 0 0 1-.572-.571V8.57H4.571A.573.573 0 0 1 4 8c0-.314.257-.571.571-.571h2.857V4.57C7.428 4.257 7.685 4 8 4s.571.257.571.571V7.43h2.857c.315 0 .572.257.572.571a.573.573 0 0 1-.572.571"
        />
      </g>
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h16v16H0z" />
      </clipPath>
      <filter
        id="d"
        width={22.857}
        height={22.857}
        x={-3.429}
        y={-2.857}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={0.571} />
        <feGaussianBlur stdDeviation={1.714} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_8884_3214" />
        <feBlend in="SourceGraphic" in2="effect1_dropShadow_8884_3214" result="shape" />
      </filter>
    </defs>
  </svg>
));
